import { useTranslation } from 'react-i18next'
import { WavyLineDecoration } from '@/shared/components/wavy-line-decoration'

export function DayCardSkeleton() {
  const { t } = useTranslation()
  return (
    <div className="relative h-full pt-[18px]">
      <div className="relative h-full overflow-hidden rounded-[40px] bg-app-grey-300">
        <WavyLineDecoration
          colorLight="var(--theme-grey-300)"
          colorDark="var(--theme-grey-400)"
        />

        {/* Shimmer sweep */}
        <div
          className="pointer-events-none absolute inset-0 z-[3] -skew-x-12"
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%)',
            animation: 'skeleton-shimmer 1.8s ease-in-out infinite',
          }}
        />

        {/* Loading label — same structure/styles as DayCard */}
        <div className="relative z-[2] flex h-full flex-col items-center px-4 pt-4">
          <div className="flex flex-col items-center">
            <span
              aria-hidden
              className="invisible select-none text-[160px] leading-none uppercase"
              style={{
                fontWeight: 900,
                letterSpacing: '3.2px',
              }}
            >
              00
            </span>
            <h2
              className="-mt-[80px] text-center font-display text-[48px] font-medium leading-[56px] text-white"
              style={{ letterSpacing: '0.96px' }}
            >
              {t('loading_screen_loading_text')}
            </h2>
          </div>
        </div>
      </div>
    </div>
  )
}
